import { assetUrl } from "fusion-core";
import Accordion from "../../../shared/components/accordion";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { useForm } from "react-hook-form";
import QuoteFormWrapper from "../../../shared/components/quoteFormWrapper";
import FormNavigationButtons from "../../../shared/components/FormNavigationButtons";
import BuyStep from "../enums/BuyStep";
import { handleNext } from "../../../shared/utils/navigationUtils";
import Loader from "../../../shared/components/Loader";
import useQuoteStore from "../../quote/store/QuoteStore";
import { useNavigate } from "fusion-plugin-react-router";
import { fetchPaymentOptions } from "../services/buyService";
import useBuyStore from "../store/BuyStore";
import { TAXI_QUOTE_BRANDREF } from "../../../config/config";
import { useEffect, useState } from "react";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { HotjarEventNames } from "../../../shared/utils/hotjarEventNames";
import { TrackHotjarEvent } from "../../../shared/utils/trackHotjarEvent";

const TbDocuments = () => {
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm();

  let STATE = useAppStateStore();

  const navigate = useNavigate();
  const buyStore = useBuyStore.getState();
  const main = assetUrl("../../../styles/main.css");
  const riskObjectId = useQuoteStore.getState().quote?.risk?.riskObjectId;
  const brandRef = TAXI_QUOTE_BRANDREF;

  const [loadingStates, setLoadingStates] = useState({});

  useEffect(() => {
    TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TBDOCUMENTS_ENTERED);
  }, []);

  const onSubmit = async (data) => {
    STATE.setPaymentsLoading(true);
    TrackHotjarEvent(HotjarEventNames.TAXI_QUOTE_TBDOCUMENTS_NEXT_CLICKED);

    const paymentOptionsRequestBody = {
      brandRef: brandRef,
      RiskObjectId: riskObjectId || null,
      RiskObjectHistoryId: 1,
    };

    buyStore.setObject("paymentOptionsRequestBody", paymentOptionsRequestBody);

    try {
      await fetchPaymentOptions(paymentOptionsRequestBody, navigate);
      handleNext(BuyStep.TB_E_PAYMENT, STATE);
    } catch (error) {
      console.error("Error fetching payment options:", error);
    } finally {
      STATE.setPaymentsLoading(false);
    }
  };

  const documents =
    buyStore.getObject("vaultResponse")?.templateItems?.map((item) => ({
      title: item.templateItemDescription,
      link: item.templateDocumentGetUrl,
      linkDescription: item.templateExplanation,
      webDownloadFileName: item.webDownloadFileName.split(".")[0],
    })) || [];

  if (STATE.paymentsLoading) {
    return <Loader text="Fetching your payment options..." />;
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <link rel="stylesheet" href={main} />
      </Helmet>
      <QuoteFormWrapper>
        <div>
          <h1 className="margin-bottom-20 margin-top-0">Your Documents</h1>
          <p className="margin-bottom-30">
            Please take your time to read through and understand your documents
          </p>
          {documents.map((doc, index) => (
            <Accordion
              key={index}
              title={doc.title}
              link={doc.link}
              linkDescription={doc.linkDescription}
              isLoading={loadingStates[index] || false}
              setLoading={(isLoading) =>
                setLoadingStates((prev) => ({ ...prev, [index]: isLoading }))
              }
              name={doc.webDownloadFileName}
            />
          ))}

          <div className="termsContainer">
            <input
              type="checkbox"
              id="docTermsAccepted"
              {...register("docTermsAccepted", {
                required:
                  "You cannot proceed to purchase without confirming acceptance and understanding of our Terms of Business and your policy documents.",
              })}
            />
            <label htmlFor="docTermsAccepted" className="termsLabel">
              I have read and understood my policy documents and agree to the
              terms of business.
            </label>
            {errors.docTermsAccepted && (
              <span className="errorField font-12">
                {errors.docTermsAccepted.message}
              </span>
            )}
          </div>
        </div>
      </QuoteFormWrapper>

      <FormNavigationButtons
        prevStep={BuyStep.TB_ADDON_RECOMMENDATIONS}
        isValid={isValid}
      />
    </form>
  );
};

export default TbDocuments;
